import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { BRAND, publicAsset } from '../../constants/brand';
import { siteCopy } from '../../content/siteCopy';

const Header = () => {
  const [isFixed, setIsFixed] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const downloadCtaLabel = siteCopy.pricing?.ctaLabel ?? 'Get the app';

  const handleScroll = () => {
    setIsFixed(window.scrollY > 50);
  };

  const toggleNavbar = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={isFixed ? '' : 'fix_style fixed'}>
      <div className="container">
        <nav className="navbar navbar-expand-lg">
          <Link className="navbar-brand" to="/">
            <img src={publicAsset(BRAND.logos.white)} alt={`${BRAND.appName} logo`} />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleNavbar}
            aria-controls="navbarSupportedContent"
            aria-expanded={isExpanded}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon">
              <span className={`toggle-wrap ${isExpanded ? 'active' : ''}`}>
                <span className="toggle-bar" />
              </span>
            </span>
          </button>

          <div
            className={`collapse navbar-collapse ${isExpanded ? 'show' : ''}`}
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/aboutus">
                  About
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/features">
                  Features
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to={{ pathname: '/', hash: '#pricing_sec' }}
                  onClick={() => setIsExpanded(false)}
                >
                  Pricing
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  Contact
                </Link>
              </li>
              <li className="nav-item">
                <div className="btn_block">
                  <Link
                    className="nav-link dark_btn"
                    to={{ pathname: '/', hash: '#download_sec' }}
                    onClick={() => setIsExpanded(false)}
                  >
                    {downloadCtaLabel} <i className="icofont-arrow-right" />
                  </Link>
                  <div className="btn_bottom" />
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
